export interface BatchAvLibraryMarcRegRequest {
  startNumFrom: string
  startNumTo: string
  rdoMarcType: string
  registrationDate: string
  newPublicationDate: string
  rdoMarcAlreadyExists: string
  isNotCollectionReplace: boolean
  collectionForm: string
  isKanaConvertToFullWidth: boolean
  rdoTraderDonor: string
  traderType: string
  donorType: string
  acceptDate: string
  acceptType: string
  budgetYear: string
  budgetBranch: string
  budgetDepartment: string
  expenseCode: string
  equipmentConsumptionCode: string
  isCalcPrice: boolean
  collectionStatus: string
  branchCode: string
  shelfType: string
  collectionType: string
  department: string
  handlingType: string
  storeCode: string
  appendixCode: string
  isCheckDigit: boolean
  inputFileMarc: string
  memo: string
  batchType: string
}

export function BatchAvLibraryMarcRegRequestToJSON(
  value: BatchAvLibraryMarcRegRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    rdo_marc_type: value.rdoMarcType,
    registration_date: value.registrationDate,
    new_publication_date: value.newPublicationDate,
    rdo_marc_already_exists: value.rdoMarcAlreadyExists,
    is_not_collection_replace: value.isNotCollectionReplace,
    collection_form: value.collectionForm,
    is_kana_convert_to_full_width: value.isKanaConvertToFullWidth,
    rdo_trader_donor: value.rdoTraderDonor,
    trader_type: value.traderType,
    donor_type: value.donorType,
    accept_date: value.acceptDate,
    accept_type: value.acceptType,
    budget_year: value.budgetYear,
    budget_branch: value.budgetBranch,
    budget_department: value.budgetDepartment,
    expense_code: value.expenseCode,
    equipment_consumption_code: value.equipmentConsumptionCode,
    is_calc_price: value.isCalcPrice,
    collection_status: value.collectionStatus,
    branch_code: value.branchCode,
    shelf_type: value.shelfType,
    collection_type: value.collectionType,
    department: value.department,
    handling_type: value.handlingType,
    store_code: value.storeCode,
    appendix_code: value.appendixCode,
    is_check_digit: value.isCheckDigit,
    input_file_marc: value.inputFileMarc,
    memo: value.memo,
    batch_type: value.batchType
  }
}
